export default "__VITE_ASSET__Bkpq2bzl__"